module.exports = __webpack_public_path__ + "static/img/77d42a5630ed1f8fd86b560310f5f750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img2.png
// module id = 9NFm
// module chunks = 1